import { render, staticRenderFns } from "./PL_twoTout.vue?vue&type=template&id=23b2e383&"
import script from "./PL_twoTout.vue?vue&type=script&lang=js&"
export * from "./PL_twoTout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports